import { render, staticRenderFns } from "./global-notification-view.vue?vue&type=template&id=a381af52"
import script from "./global-notification-view.vue?vue&type=script&lang=js"
export * from "./global-notification-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports